import { NavigateFunction } from 'react-router-dom'

import { CaseVersion, ClientVersion, SearchResultCase, SearchResultItem } from '@acre/graphql'

import { DEFAULT_EMPTY_OPTION } from '../GlobalSearchOption/GlobalSearchOption'

const formatMultipleClientNameTag = (clients: ClientVersion[]) => {
  // Natural clients often have null value for is_natural_person field
  const company = clients.find((client) => client.details?.is_natural_person === false)

  if (company?.details?.organisation_name) {
    return company.details.organisation_name
  }

  return clients
    .map((client) => `${client.details.first_name || ''} ${client.details.last_name || ''}`.trim())
    .join(' + ')
}

export const formatCaseOption = (
  caseInput: CaseVersion,
  postcode: string,
  closeModalSearch: () => void,
  trackCaseView: (caseId: string) => void,
  navigate: NavigateFunction,
) => {
  const { details } = caseInput
  const { status, preference_mortgage_reason, owner_organisation } = details
  return {
    id: caseInput.id,
    doctype: 'client_case',
    override_name: details.clients?.length ? formatMultipleClientNameTag(details.clients) : DEFAULT_EMPTY_OPTION,
    postcode: postcode,
    organisation_name: owner_organisation?.name,
    Cases: [
      {
        id: caseInput.id,
        case_status: status,
        case_reason: preference_mortgage_reason,
      } as SearchResultCase,
    ],
    onClick: () => {
      closeModalSearch()
      trackCaseView(caseInput.id)
      navigate(`/cases/${caseInput.id}/overview`, { replace: true })
    },
  } as SearchResultItem
}
